const transformBreakpoints = (breakpoints = {}) => {
  const sizeMappings = {
    s: '(min-width: 480px)',
    m: '(min-width: 768px)',
    l: '(min-width: 1024px)',
    xl: '(min-width: 1280px)',
    xxl: '(min-width: 1420px)',
  };

  return Object.keys(breakpoints).reduce((result, item) => {
    const updatedKey = sizeMappings[item] || item;
    result[updatedKey] = breakpoints[item];
    return result;
  }, {});
};

export const transformConfig = (config) => {
  const { breakpoints } = config;

  if (breakpoints) {
    return {
      ...config,
      breakpoints: transformBreakpoints(breakpoints),
    };
  }

  return config;
};
